import React, { memo } from 'react';

import Button from 'react-bootstrap/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

import i18n from '../messages.json';

const PHASE = {
  INPUT: 'input',
  SENDING: 'sending',
  RESULTS: 'results',
};

/**
 * Modal-footer dispatcher for the Send Test dialog.
 * - Results phase  → single Done button (closes the modal via onHide).
 * - Input / Sending → Cancel + Send Test buttons; Cancel disabled during send,
 *   Send Test disabled until `canSubmit`.
 *
 * Props
 *   phase:     'input' | 'sending' | 'results'
 *   canSubmit: boolean — gates the primary Send Test button in input phase
 *   onHide:    () => void — Cancel / Done
 *   onSubmit:  () => void — Send Test
 */
const SendTestFooter = ({ phase, canSubmit, onHide, onSubmit }) => {
  if (phase === PHASE.RESULTS) {
    return (
      <Button variant='primary' onClick={onHide}>
        {i18n.ink.notification.buttons.done}
      </Button>
    );
  }

  return (
    <>
      <Button variant='light' onClick={onHide} disabled={phase === PHASE.SENDING}>
        {i18n.ink.notification.buttons.cancel}
      </Button>
      <Button variant='primary' onClick={onSubmit} disabled={!canSubmit}>
        <FontAwesomeIcon icon={faPaperPlane} className='mr-2' />
        <span className='ml-1'>{i18n.ink.notification.buttons.sendTest}</span>
      </Button>
    </>
  );
};

export default memo(SendTestFooter);
